export default __webpack_public_path__ + "static/media/CorujaAssignModal.5758e50b.svg";